<div class="supplier-dashboard">

  <div class="mockup-note" role="note">
    <mat-icon>science</mat-icon>
    <div>
      <strong>Mockup with sample data.</strong>
      Nothing here is live. The real dashboard shows the logged-in supplier's own figures, updated on the 1st
      of each month alongside their PDF report.
    </div>
  </div>

  <!-- Header -->
  <div class="dash-header" fxLayout="row wrap" fxLayoutAlign="space-between center" fxLayoutGap="16px">
    <div>
      <div class="eyebrow">Supplier dashboard</div>
      <h2>{{ supplierName }}</h2>
      <div class="sub">Updated 1 October 2026 · counted across every builder website running a situ 3D home</div>
    </div>
    <mat-form-field appearance="fill" class="month-select">
      <mat-label>Month</mat-label>
      <mat-select [(value)]="selectedMonth">
        <mat-option *ngFor="let m of months" [value]="m">{{ m }}</mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <!-- Headline numbers -->
  <div class="kpis">
    <div class="kpi lead">
      <div class="kpi-label">Product impressions</div>
      <div class="kpi-num">{{ kpis.impressions | number }}</div>
      <div class="kpi-sub" [class.up]="kpis.impressionsChange > 0" [class.down]="kpis.impressionsChange < 0">
        <mat-icon inline>{{ kpis.impressionsChange >= 0 ? 'trending_up' : 'trending_down' }}</mat-icon>
        {{ kpis.impressionsChange | number: '1.1-1' }}% on August
      </div>
    </div>
    <div class="kpi">
      <div class="kpi-label">Showcase opens</div>
      <div class="kpi-num">{{ kpis.opens | number }}</div>
      <div class="kpi-sub">1 in {{ oneInOpens | number }} impressions · <span class="up">+{{ kpis.opensChange | number: '1.1-1' }}%</span></div>
    </div>
    <div class="kpi">
      <div class="kpi-label">Products seen</div>
      <div class="kpi-num">{{ kpis.productsSeen }}</div>
      <div class="kpi-sub">of {{ kpis.productsLive }} live products</div>
    </div>
    <div class="kpi">
      <div class="kpi-label">Builders</div>
      <div class="kpi-num">{{ kpis.builders }}</div>
      <div class="kpi-sub">{{ kpis.buildersNew }} new this month</div>
    </div>
  </div>

  <!-- Trend -->
  <mat-card>
    <mat-card-header fxLayout="row wrap" fxLayoutAlign="space-between center">
      <mat-card-title>Last 12 months</mat-card-title>
      <mat-button-toggle-group [value]="trendMeasure" (change)="setTrendMeasure($event.value)" aria-label="Measure">
        <mat-button-toggle value="impressions">Impressions</mat-button-toggle>
        <mat-button-toggle value="opens">Showcase opens</mat-button-toggle>
      </mat-button-toggle-group>
    </mat-card-header>
    <mat-card-content>
      <div class="trend-chart">
        <canvas baseChart chartType="bar" [datasets]="trendData" [labels]="trendLabels" [colors]="trendColors"
          [options]="trendOptions" [legend]="false"
          [attr.aria-label]="'Monthly ' + (trendMeasure === 'impressions' ? 'impressions' : 'showcase opens') + ', October 2025 to September 2026'"
          role="img"></canvas>
      </div>
    </mat-card-content>
  </mat-card>

  <!-- Products -->
  <mat-card>
    <mat-card-header>
      <mat-card-title>Your products</mat-card-title>
      <mat-card-subtitle>Most-seen products this month</mat-card-subtitle>
    </mat-card-header>
    <mat-card-content>
      <div class="table-scroll">
        <table mat-table [dataSource]="products" class="dash-table">
          <ng-container matColumnDef="product">
            <th mat-header-cell *matHeaderCellDef>Product</th>
            <td mat-cell *matCellDef="let r">{{ r.name }}</td>
          </ng-container>
          <ng-container matColumnDef="builders">
            <th mat-header-cell *matHeaderCellDef class="num">Builders</th>
            <td mat-cell *matCellDef="let r" class="num">{{ r.builders }}</td>
          </ng-container>
          <ng-container matColumnDef="impressions">
            <th mat-header-cell *matHeaderCellDef class="num">Impressions</th>
            <td mat-cell *matCellDef="let r" class="num">{{ r.impressions | number }}</td>
          </ng-container>
          <ng-container matColumnDef="opens">
            <th mat-header-cell *matHeaderCellDef class="num">Showcase opens</th>
            <td mat-cell *matCellDef="let r" class="num">{{ r.opens | number }}</td>
          </ng-container>
          <ng-container matColumnDef="openRate">
            <th mat-header-cell *matHeaderCellDef class="num">Open rate</th>
            <td mat-cell *matCellDef="let r" class="num">{{ openRate(r) }}</td>
          </ng-container>
          <ng-container matColumnDef="change">
            <th mat-header-cell *matHeaderCellDef class="num">vs August</th>
            <td mat-cell *matCellDef="let r" class="num" [class.up]="r.change > 0" [class.down]="r.change < 0">
              {{ r.change > 0 ? '+' : '' }}{{ r.change | number: '1.1-1' }}%
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="productColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: productColumns;"></tr>
        </table>
      </div>
      <p class="footnote">
        Plus {{ otherProducts.count }} more products: {{ otherProducts.impressions | number }} impressions,
        {{ otherProducts.opens }} showcase opens.
      </p>
    </mat-card-content>
  </mat-card>

  <!-- Where they appear -->
  <mat-card>
    <mat-card-header>
      <mat-card-title>Where your products appear</mat-card-title>
      <mat-card-subtitle>Share of your impressions this month</mat-card-subtitle>
    </mat-card-header>
    <mat-card-content>
      <mat-tab-group animationDuration="0ms">
        <mat-tab label="Builders">
          <ng-container *ngTemplateOutlet="shareList; context: { rows: builders }"></ng-container>
        </mat-tab>
        <mat-tab label="Home designs">
          <ng-container *ngTemplateOutlet="shareList; context: { rows: homeDesigns }"></ng-container>
        </mat-tab>
        <mat-tab label="Themes">
          <ng-container *ngTemplateOutlet="shareList; context: { rows: themes }"></ng-container>
        </mat-tab>
        <mat-tab label="Rooms">
          <ng-container *ngTemplateOutlet="shareList; context: { rows: rooms }"></ng-container>
        </mat-tab>
        <mat-tab label="States">
          <ng-container *ngTemplateOutlet="shareList; context: { rows: states }"></ng-container>
        </mat-tab>
      </mat-tab-group>
    </mat-card-content>
  </mat-card>

  <!-- Category context (situ PULSE) -->
  <mat-card>
    <mat-card-header>
      <mat-card-title>Your categories across situ</mat-card-title>
      <mat-card-subtitle>From situ PULSE. Platform totals only; no other supplier's figures are shown.</mat-card-subtitle>
    </mat-card-header>
    <mat-card-content>
      <div class="categories">
        <div class="category" *ngFor="let c of categories">
          <div class="cat-head">
            <span class="cat-name">{{ c.name }}</span>
            <span class="cat-meta">{{ c.suppliers }} suppliers</span>
          </div>
          <div class="cat-stats">
            <div>
              <div class="kpi-label">Category impressions</div>
              <div class="cat-num">{{ c.categoryImpressions | number }}</div>
              <div class="kpi-sub" [class.up]="c.categoryChange > 0" [class.down]="c.categoryChange < 0">
                {{ c.categoryChange > 0 ? '+' : '' }}{{ c.categoryChange | number: '1.1-1' }}% on August
              </div>
            </div>
            <div>
              <div class="kpi-label">Your share of the category</div>
              <div class="cat-num">{{ categoryShare(c) | number: '1.0-0' }}%</div>
              <div class="kpi-sub">{{ c.yourImpressions | number }} of {{ c.categoryImpressions | number }} impressions</div>
            </div>
          </div>
          <div class="share-track" role="img" [attr.aria-label]="'Your share of ' + c.name + ': ' + (categoryShare(c) | number: '1.0-0') + '%'">
            <div class="share-fill" [style.width.%]="categoryShare(c)"></div>
          </div>
        </div>
      </div>
      <p class="footnote">
        A category is only shown when at least {{ minSuppliers }} suppliers are in it, so no single competitor's
        figures can be worked out.
      </p>
    </mat-card-content>
  </mat-card>

</div>

<ng-template #shareList let-rows="rows">
  <ul class="share-list">
    <li *ngFor="let r of rows">
      <span class="share-name">{{ r.name }}</span>
      <span class="share-bar"><span class="share-fill" [style.width]="barWidth(r, rows)"></span></span>
      <span class="share-num">{{ r.impressions | number }}</span>
      <span class="share-pct">{{ share(r, rows) | number: '1.0-0' }}%</span>
    </li>
  </ul>
</ng-template>
